import { useCallback } from 'react';
import { useFlagService } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from '../../common/messages.tsx';

export const useGenericFlag = () => {
	const { formatMessage } = useIntl();
	const { showFlag } = useFlagService();

	return useCallback(() => {
		showFlag({
			type: 'error',
			title: formatMessage(messages.projectConnectionFailureTitle),
			description: formatMessage(messages.projectConnectionUnexpectedFailureDescription),
		});
	}, [showFlag, formatMessage]);
};
